import { render, staticRenderFns } from "./AutoCompletePanel.vue?vue&type=template&id=38ab5e70&scoped=true&lang=pug"
import script from "./AutoCompletePanel.vue?vue&type=script&lang=js"
export * from "./AutoCompletePanel.vue?vue&type=script&lang=js"
import style0 from "./AutoCompletePanel.vue?vue&type=style&index=0&id=38ab5e70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ab5e70",
  null
  
)

export default component.exports